<template>
  <div class="modal fade" id="promotionadd" role="dialog" @click="$emit('close')" :style="{ 'z-index': zIndex || 1050 }">
    <div class="modal-dialog modal-xl" @click.stop>
      <div class="modal-content">
        <div class="modal-body">
          <div class="alert alert-danger text-center p-xxs m-b-xs" v-if="countData === 0">
            <h5 class="m-b-none"><router-link :to="{path: '/products-new'}">こちら</router-link>から商品登録をしてください。</h5>
          </div>
          <div>
            <div class="panel products-table" ref="promotionModal" style="position: relative">
              <base-table
                :url="'PromotionProduct/available'"
                :filterFn="agentFilterFn"
                :extraUrl="['Product/get-image-name']"
                :extraUrlMode="true"
                :columns="promotionColumns"
                :isSearchable="true"
                :needExtraData="true"
                :loadingTableMode="true"
                :clientMode="true"
                :checkedItems="checkedItems"
                :isShowBtnBulkCreate="true"
                ref="promotionTable"
                @countData="countData = $event"
                @extraData="extraData = $event"
                @keyword="onHandleSearch"
                @zIndex="zIndex = $event"
                @checkBoxAll="checkBoxAll"
                @bulkAdd="bulkAddPromotion"
              >
                <template slot="bulkCreateExtra">
                  <img
                    src="https://image-yoshino.sakura.ne.jp/monster/SaleMonAgent.png"
                    alt="SaleMon Agent"
                    class="agent-logo"
                  />
                  <toggle-button
                    v-model="isShowAgentFilter"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    :height="26"
                    :width="60"
                    :sync="true"
                    :disabled="isAgentLoading || isBasicPlan"
                    @change="onToggleAgentFilter"
                  />
                  <span v-if="isBasicPlan" class="plan-gate-label">
                    <span class="text-premium"><i class="fa fa-lock"></i> プレミアム限定機能</span>
                    <span class="plan-gate-tooltip">
                      セルモンエージェントで出品を推奨している商品のみを表示します。<br>
                      <router-link to="/setting/plan-info">プレミアムプランにアップグレードする</router-link>
                    </span>
                  </span>
                  <span v-else class="plan-gate-label">
                    推奨商品のみ表示する
                    <span class="plan-gate-tooltip"> セルモンエージェントで広告の登録を推奨している商品のみを表示します。<br></span>
                  </span>
                  <span v-if="checkedItems.length > 0" class="agent-filter-count">{{ checkedItems.length }}件選択中</span>
                </template>
                <template slot="checkBoxAll" slot-scope="props">
                  <input type="checkbox" :value="props.rowData.asin" v-model="checkedItems" @change="refreshCheckAll">
                </template>
                <template slot="image" slot-scope="props">
                  <loading-block :value="props.rowData.image" type="image">
                    <img :src="prepareImgSrc(props.rowData.image)" class="product-img"/>
                  </loading-block>
                </template>
                <template slot="productName" slot-scope="props">
                  <loading-block :value="props.rowData.productName" type="string">
                    <a class="text--underline" :href="'https://www.amazon.co.jp/gp/offer-listing/' + props.rowData.asin" target="_blank">
                      {{props.rowData.productName}}
                    </a>
                  </loading-block>
                </template>
                <template slot="action" slot-scope="props">
                  <button class="btn btn-warning" @click="addPromotion(props.rowData)">追加</button>
                </template>
              </base-table>
              <div class="row m-b-sm">
                <div class="flexbox justify-right">
                  <button class="btn btn-warning ver-middle w-120 mr-r-10" @click="onHandleReload">
                    再読み込み
                  </button>
                  <div data-dismiss="modal" @click="$emit('close')">
                    <button class="btn ver-middle w-120">閉じる</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable'
import LoadingBlock from '@/components/LoadingBlock'
import PromotionService from '@/services/promotionservice'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    BaseTable,
    LoadingBlock
  },

  data () {
    return {
      error: null,
      loader: null,
      zIndex: null,
      countData: null,
      extraData: null,
      keyword: null,
      isShowAgentFilter: false,
      isAgentLoading: false,
      agentDataLoaded: false,
      agentRecommendedMap: {},
      promotionColumns: [
        {
          title: '<input type="checkbox" id="checkbox-all">',
          name: 'checkBoxAll',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-30 th-checkbox-all',
          sortable: false
        },
        {
          title: '画像',
          name: 'image',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-130',
          sortable: false
        },
        {
          title: 'ASIN',
          name: 'asin',
          cellClass: 'text-center',
          headerClass: 'w-150'
        },
        {
          title: '商品名',
          name: 'productName',
          cellClass: 'text-left',
          customCell: true,
          headerClass: 'product-name'
        },
        {
          title: '',
          name: 'action',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-100',
          sortable: false
        }
      ],
      checkedItems: []
    }
  },

  computed: {
    isBasicPlan () {
      return this.$store.getters.getUser.memberPlan === '0'
    },
    agentFilterFn () {
      return this.isShowAgentFilter ? (item) => this.agentRecommendedMap[item.asin] === true : null
    }
  },

  watch: {
    countData (newVal, oldVal) {
      this.$emit('checkAvailableItem', newVal, this.keyword)
    },
    keyword (newVal, oldVal) {
      this.$emit('checkAvailableItem', this.countData, newVal)
    },
    isShow (newVal) {
      if (!newVal && !this.isLoadingButton) {
        this.$refs.promotionTable.reload(false, false, false, true)
      }
    }
  },

  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    isLoadingButton: {
      type: Boolean
    }
  },
  created () {
    this.loader = this.$loading.show({
      container: this.$refs.promotionModal
    })
  },
  mounted () {
    $('#promotionadd').modal('show')
    this.$events.listen('done', (url) => {
      url === 'PromotionProduct/available' && this.loader && this.loader.hide()
    })
  },

  methods: {
    async onToggleAgentFilter () {
      this.checkedItems = []
      if (this.isShowAgentFilter && !this.agentDataLoaded) {
        this.isAgentLoading = true
        try {
          const items = await PromotionService.getAvailableWithAgentData()
          items.forEach(item => {
            this.agentRecommendedMap[item.asin] = item.isAgentRecommended === true
          })
          this.agentDataLoaded = true
        } catch (e) {
          this.isShowAgentFilter = false
        } finally {
          this.isAgentLoading = false
        }
      }
      this.$nextTick(() => {
        this.$refs.promotionTable.applyFilter()
      })

      let logParams = {
        name: eventCode.promotion.request_tab.add_by_amazon_modal.click_show_recommendations_button,
        properties: {
          isShowAgent: this.isShowAgentFilter
        }
      }
      EventService.postTrackLog(logParams)
    },

    prepareImgSrc (value) {
      return value || `${process.env.NODE_DOMAIN}/static/dists/img/noimg.png`
    },
    addPromotion (item) {
      const payload = {
        record: {
          asin: item.asin
        }
      }
      let logParams = {
        name: eventCode.promotion.request_tab.add_by_amazon_modal.click_add_button,
        properties: {
          product_asin: item.asin
        }
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show({
        container: this.$refs.promotionModal
      })
      PromotionService.addPromotionProduct(payload)
        .then(response => {
          this.$refs.promotionTable.handleData(item, 'delete')
          this.checkedItems = this.checkedItems.filter(checkedItemAsin => checkedItemAsin !== item.asin)
          this.$emit('isAddPromotion')
          this.zIndex = null
          this.loader && this.loader.hide()
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
          this.zIndex = 1040
          this.loader && this.loader.hide()
          this.err = error
        })
    },
    onHandleReload () {
      let logParams = {
        name: eventCode.promotion.request_tab.add_by_amazon_modal.click_reload_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.$emit('toggleButton', true)
      this.$refs.promotionTable.reload(true)
    },

    formatAmount (value) {
      return (value === null || typeof value === 'undefined') ? '' : `¥${Util.formatMoney(value)}`
    },

    sortExpectedAmount (data, order) {
      if (!order) {
        return [...data]
      } else if (order === 'desc') {
        return [...data].sort((before, after) => before.offerPrice - after.offerPrice)
      }
      return [...data].sort((before, after) => after.offerPrice - before.offerPrice)
    },
    onHandleSearch (keywordValue) {
      this.keyword = keywordValue
      let logParams = {
        name: eventCode.promotion.request_tab.add_by_amazon_modal.click_filter_button,
        properties: {
          keyword: keywordValue
        }
      }
      EventService.postTrackLog(logParams)
    },
    refreshCheckAll () {
      const allItems = this.$refs.promotionTable.originalData || []
      const items = this.agentFilterFn ? allItems.filter(this.agentFilterFn) : allItems
      this.checkAll = items.length > 0 && this.checkedItems.length === items.length
    },
    checkBoxAll (value) {
      const allItems = this.$refs.promotionTable.originalData || []
      const items = this.agentFilterFn ? allItems.filter(this.agentFilterFn) : allItems
      this.checkAll = value
      this.checkedItems = []
      if (this.checkAll) {
        items.forEach(item => {
          this.checkedItems.push(item.asin)
        })
      }
    },
    bulkAddPromotion () {
      const payload = {
        asins: this.checkedItems
      }

      let logParams = {
        name: eventCode.promotion.request_tab.add_by_amazon_modal.click_add_all_button,
        properties: payload
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show({
        container: this.$refs.promotionModal
      })
      PromotionService.addPromotionProducts(payload)
        .then(response => {
          this.$refs.promotionTable.handleData(payload.asins, 'deleteAll')
          this.$emit('isAddPromotion')
          this.zIndex = null
          this.checkAll = false
          this.checkedItems = []
          this.loader && this.loader.hide()
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
          this.zIndex = 1040
          this.loader && this.loader.hide()
          this.err = error
        })
    }
  },

  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>
<style scoped>
  .agent-logo {
    height: 28px;
    object-fit: contain;
  }
  #promotionadd /deep/ .box-base-table-search {
    display: block;
    justify-content: unset;
    align-items: unset;
    flex-wrap: unset;
  }
  #promotionadd /deep/ .box-base-table-search .search-multiple {
    flex-grow: unset;
    margin-right: unset;
    display: flex;
    align-items: center;
  }
  #promotionadd /deep/ .box-base-table-search .search-multiple input {
    margin-right: 30px;
  }
  #promotionadd /deep/ .th-checkbox-all {
    padding: 6px;
    position: relative;
  }
  #promotionadd /deep/ .th-checkbox-all input {
    position: absolute;
    top: 8px;
    left: 0;
    right: 0;
  }
  @media (max-width: 1200px) {
    #promotionadd /deep/ .box-base-table-search .sale-detail-search {
      display: block;
      justify-content: unset;
    }

    #promotionadd /deep/ .box-base-table-search .sale-detail-search .search-block {
      display: flex;
      margin-bottom: 10px;
      margin-right: 0;
    }
    #promotionadd /deep/ .box-base-table-search .sale-detail-search .search-block label {
      width: 68px;
      margin-right: 0;
    }
    #promotionadd /deep/ .box-base-table-search .sale-detail-search .search-block input[name="detail"] {
      width: 184px;
    }
    #promotionadd /deep/ .box-base-table-search .sale-detail-search .search-block select[name="mallCode"] {
      width: 184px;
    }
    #promotionadd /deep/ .box-base-table-search .sale-detail-search .box-detail-btn-search {
      margin-left: 68px;
    }
  }
  @media (min-width: 1200px) {
    #promotionadd /deep/ .box-base-table-search .sale-detail-search {
      margin-right: 0;
    }
  }
  #promotionadd /deep/ .table-wrapper {
    max-height: 450px;
    overflow-y: auto;
  }
  #promotionadd /deep/ thead th {
    position: sticky !important;
    top: -1px;
    z-index: 1;
  }
  .agent-filter-count {
    font-size: 12px;
    color: #888;
    margin-left: 4px;
  }
  .plan-gate-label {
    position: relative;
    cursor: default;
    font-weight: bold;
  }
  .plan-gate-tooltip {
    display: none;
    position: absolute;
    bottom: calc(100% + 8px);
    left: 0;
    background: #fff;
    color: #000;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 12px;
    font-weight: normal;
    white-space: nowrap;
    line-height: 1.7;
    z-index: 100;
  }
  .plan-gate-tooltip::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 14px;
    border: 6px solid transparent;
    border-top-color: #fff;
  }
  .plan-gate-tooltip::before {
    content: '';
    position: absolute;
    top: calc(100% + 1px);
    left: 14px;
    border: 6px solid transparent;
    border-top-color: #ccc;
  }
  .plan-gate-tooltip /deep/ a {
    color: #9bb8f5;
    text-decoration: underline;
  }
  .plan-gate-label:hover .plan-gate-tooltip {
    display: block;
  }
  .text-premium {
    color: #bf9000;
  }
</style>



// WEBPACK FOOTER //
// src/view/promotion/PromotionAdd.vue